<template>
  <div class="auth-layout-form">
    <h4 class="auth-layout-title">فراموشی رمز عبور</h4>
    <p class="auth-layout-msg">
      شماره‌ تلفنی که قبلاً با آن ثبت نام کرده‌اید، وارد کنید.
    </p>
    <b-form @submit.prevent="onSubmit">
      <b-form-group>
        <b-form-input
          placeholder="تلفن"
          @update="phoneChangeHandler"
          :state="this.validPhone"
          v-model="form.phone.value"
        />
        <b-form-invalid-feedback class="text-right" :state="this.validPhone">
          {{ form.phone.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <loading-btn
          block
          type="submit"
          variant="primary"
          :disabled="disabled || loader"
          :loading="loader"
        >
          ارسال
        </loading-btn>
      </b-form-group>
      <error-messages
        :messages="alertMessage"
        :show="showMessage"
        :dismissible="true"
        @dismissed="dismissedError"
      />
    </b-form>
    <div class="auth-layout-footer">
      <router-link to="/login">به حساب کاربری خود وارد شوید.</router-link>
    </div>
  </div>
</template>

<script>
import { phoneVerificationToken } from "@/services/auth";
import { mapState, mapActions } from "vuex";
import {
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_HIDE_LOADER
} from "@/store/mutation-types";
import LoadingBtn from "../../../components/LoadingBtn/LoadingBtn.vue";
import ErrorMessages from "../../../components/ErrorMessages/ErrorMessages.vue";
export default {
  components: { LoadingBtn, ErrorMessages },
  name: "PhoneStep1",
  props: {
    step: { type: Number, require: true }
  },
  data() {
    return {
      form: {
        phone: { value: "", error: "" },
        verifyCode: { value: "", error: "" },
        password: { value: "", error: "" },
        confirmPassword: { value: "", error: "" }
      },
      validPhone: null,
      disabled: true,
      errorMessages: [],
      showError: false
    };
  },
  computed: {
    ...mapState("auth", ["loader", "alertMessage", "showMessage"])
  },
  methods: {
    dismissedError: function() {
      this[HIDE_MESSAGE]();
    },
    ...mapActions("auth", [
      ON_SHOW_LOADER,
      SHOW_MESSAGE,
      HIDE_MESSAGE,
      ON_HIDE_LOADER
    ]),
    onSubmit: async function() {
      this[ON_SHOW_LOADER]();
      const [error, data] = await phoneVerificationToken({
        phoneNumber: this.form.phone.value
      });
      if (error) this[SHOW_MESSAGE](error);
      else {
        if (data.apiStatus === 200) {
          this[ON_HIDE_LOADER]();
          this.$emit("setForm", this.form);
          this.$emit("next");
        } else {
          this[SHOW_MESSAGE](data.apiErrors);
        }
      }
    },
    phoneChangeHandler: function(val) {
      const reg = /^[0-9]*$/;
      if (val === "") {
        this.form.phone.error = "تلفن همراه الزامی است.";
        this.validPhone = false;
      } else {
        if (!reg.test(val)) {
          this.form.phone.error = "تلفن همراه باید عددی باشد.";
          this.validPhone = false;
        } else {
          if (val.length != 11) {
            this.form.phone.error = "تلفن همراه باید 11 رقمی باشد.";
            this.validPhone = false;
          } else {
            this.form.phone.error = "";
            this.validPhone = true;
          }
        }
      }
    }
  },
  updated() {
    if (this.validPhone) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }
};
</script>

<style></style>
